"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useServicesStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const i18n_1 = __importDefault(require("../../common/i18n"));
exports.useServicesStore = (0, pinia_1.defineStore)("servicesStore", {
    state: () => ({
        services: [],
    }),
    getters: {
        /*filterByRimSize(rim: number) {
      return this.services;
    },*/
        filterByRimSize: (state) => (rimSize) => {
            if (rimSize) {
                return state.services.filter((service) => service.rims && service.rims.includes(rimSize));
            }
            else {
                return state.services;
            }
        },
    },
    actions: {
        getServices(locationId, coll) {
            this.services = [];
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)("/api/services/get", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        locationId: locationId,
                        coll: coll,
                    }),
                })
                    .then((response) => {
                    if (typeof response.error !== "undefined") {
                        // refresh failed
                        reject(i18n_1.default.trans("frontend_service_error", "No services found!", "frontend"));
                        return;
                    }
                    response.forEach((item) => {
                        this.services.push(item);
                    });
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
        getAllservices(locationId) {
            this.services = [];
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)("/api/services/get", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        locationId: locationId,
                        coll: "all",
                    }),
                })
                    .then((response) => {
                    if (typeof response.error !== "undefined") {
                        // refresh failed
                        reject(i18n_1.default.trans("frontend_service_error", "No services found!", "frontend"));
                        return;
                    }
                    response.forEach((item) => {
                        this.services.push(item);
                    });
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
    },
});
